<template>
  <div class="main text-left">
    <div class="form-group">
      <label class="text-muted small">新しいパスワード</label>
      <input type="password" class="form-control form-control-sm" v-model="input.password" placeholder="パスワード">
    </div>
    <div class="form-group">
      <input type="password" class="form-control form-control-sm" v-model="input.password2" placeholder="パスワード再入力">
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="ok()">確定</span>
  </div>
</template>
<script>
import sx from '../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        password: '',
        password2: ''
      },
      confirmdef: {
        title: 'パスワード変更',
        msg: '継続しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  created () {
    this.$store.state.title = 'パスワード変更'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'My'
    this.$store.state.confirmdef = this.confirmdef
  },
  methods: {
    ok() {
      const that = this
      if (that.input.password != '' || that.input.password2 != '') {
        if (that.input.password != that.input.password2) {
          sx.toastError('パスワード一致していません！')
          return;
        }
        $('#myModalConfirm').modal('show')
        $("#confirm").click(function() {
          $('#myModalConfirm').modal('hide')
          if (that.$router.currentRoute.name != "PasswordChange") {
            return
          }
          var params = {
            password: that.input.password,
            corpid: 40,
            token: localStorage.getItem('token')
          }
          sx.request(
            that.$store.state.baseurl + '/app/account/passwordchange',
            params,
            function(result) {
              if (result.status === 'ok') {
                sx.toastSuccess('パスワード変更しました。<br>ログイン画面に遷移します！')
                that.$router.replace({ name: 'Login' })
              } else if (result.status === 'err') {
                sx.toastSuccess('パスワード変更に失敗しました！')
              } else {
                sx.toastSuccess('アカウントは存在しません！')
              }
            },
            function(result) {
              sx.toastError('パスワード変更に失敗しました！')
              console.log('password change failed')
            }
          )
          sx.hideWaiting()
        })
      } else {
        sx.toastError('パスワードを入力してください！')
        console.log('password must be present')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding:20px;
}
</style>
